import type { User } from "@repo/fika-shared/src/loader/user-schema.js"
import type { Replicache } from "@rocicorp/replicache"
import { leading, throttle } from "@solid-primitives/scheduled"
import { createClient } from "@supabase/supabase-js"
import { type Accessor, createEffect, createMemo, createSignal } from "solid-js"

const project = import.meta.env.VITE_SUPABASE_PROJECT
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export function initPoke(
  getUser: Accessor<User | null>,
  replicache: Replicache,
) {
  const [subscribed, setSubscribed] = createSignal(false)
  const client = createClient(`https://${project}.supabase.co`, anonKey, {
    realtime: { params: { eventsPerSecond: 1 } },
  })

  const throttledPull = leading(
    throttle,
    () => {
      replicache.pull()
    },
    1_000,
  )
  const getJwt = createMemo(() => getUser()?.jwt)
  const getId = createMemo(() => getUser()?.id)

  createEffect(() => {
    if (subscribed()) return
    const id = getId()
    const jwt = getJwt()
    if (!jwt) return

    client.realtime.setAuth(jwt)

    client
      .channel("schema-db-changes")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          filter: `user_id=eq.${id}`,
        },
        _payload => {
          throttledPull()
        },
      )
      .subscribe((status, error) => {
        setSubscribed(true)
        console.log("subscribe", status, error)
      })
  })

  return client
}
